enum WorkstationListName {
    Ready = 'ready',
    ComingUp = 'coming-up',
    History = 'history',
}
export default WorkstationListName;
